
function compareAttr(o1,o2,attrName){
    if (o1[attrName] < o2[attrName])
        return -1;
    if (o1[attrName] > o2[attrName])
        return 1;
    return 0;
}

function compareAttrStrLowerCase(o1,o2,attrName){
    let str1 =o1[attrName].toLowerCase()
    let str2 =o2[attrName].toLowerCase()
    if (str1 < str2)
        return -1;
    if (str1 > str2)
        return 1;
    return 0;
}

export {compareAttr, compareAttrStrLowerCase}